var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.864,
    height: 13.622,
    viewBox: "0 0 17.864 13.622",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1233",
    "data-name": "Group 1233",
    transform: "translate(-5503.068 -2898.189)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M5513.032,2911.811l-.817-2.452h-5.429l-.818,2.452h-2.9l4.768-13.622h3.328l4.787,13.622Zm-5.39-4.962h3.736l-1.868-5.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M5518.246,2898.189h2.686v13.622h-2.686Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAi);
export default __webpack_public_path__ + "static/media/icon-ai.e6ed058984f202a85b5d874caf44620d.svg";
export { ForwardRef as ReactComponent };